import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { PlantillaImpresion } from 'src/app/models/PlantillaImpresion/PlantillaImpresion';
import { PlantillaEmisor } from 'src/app/models/PlantillaImpresion/PlantillaEmisor';
import { Emisor } from 'src/app/models/Emisor/Emisor';
import { PlantillaImpresionService } from 'src/app/services/plantilla-impresion.service';
import { TokenStorageService } from 'src/app/services/token-storage.service';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { TipoDte } from 'src/app/models/tipoDte';
import { Page } from 'src/app/shared/models/Page';
import { UtilitiesService } from 'src/app/services/utilities.service';
import Swal from 'sweetalert2';
import { SortType } from '@swimlane/ngx-datatable';
import { EmisorService } from "src/app/services/emisor.service";

export interface PlantillaOpcion {
  label: string;
  plantilla: PlantillaImpresion;
  esPersonalizada: boolean;
  isDefault: boolean;
  asignada?: boolean;
}
export interface GrupoDte {
  codigoTipoDte: number;
  nombreTipoDte: string;
  opciones: PlantillaOpcion[];
  tiposPapel: string[];
  papelSeleccionado: string;
  opcionesFiltradas: PlantillaOpcion[];
  seleccionada: PlantillaOpcion | null;
  prevSeleccionada: PlantillaOpcion | null;
}

@Component({
  selector: 'app-mantenedor-plantillas-usuario',
  templateUrl: './mantenedor-plantillas-usuario.component.html',
  styleUrls: ['./mantenedor-plantillas-usuario.component.scss']
})
export class MantenedorPlantillasUsuarioComponent implements OnInit {

  SortType = SortType;

  public loading = false;
  public componentStarted = false;
  public rowsMantenedor: GrupoDte[] = [];
  public page: Page = new Page();
  public emisorId: string;
  public emisor = new Emisor();
  public plantillaEditando: PlantillaImpresion | null = null;
  public nuevoNombre = '';

  private editModalRef: NgbModalRef;
  private tipoDteSource: TipoDte[] = [];
  private defaultPlantillas: PlantillaImpresion[] = [];
  private allGrupos: GrupoDte[] = [];

  @ViewChild('tableRef') tableRef: any;

  constructor(
    private tokenService: TokenStorageService,
    private plantillaService: PlantillaImpresionService,
    private localStorageService: LocalStorageService,
    private ref: ChangeDetectorRef,
    private modalService: NgbModal,
    public utilities: UtilitiesService,
    private emisorService: EmisorService
  ) {
    this.emisorId = this.tokenService.getCompany();
    try {
      this.tipoDteSource = JSON.parse(this.localStorageService.getDteTypes()) as TipoDte[];
    } catch {
      this.tipoDteSource = [];
    }
  }

  ngOnInit(): void {
    this.loadData();
  }

  loadData(): void {
    this.loading = true;
    const page = new Page();
    page.pageNumber = 1;
    page.pageSize = 500;

    this.plantillaService.getPlantillasUsuario(this.emisorId, page).subscribe({
      next: (response) => {
        const todasPlantillas = ((response.data as PlantillaImpresion[]) || []).filter(p => !p.eliminadaPorUsuario);
        const companyPlantillas = todasPlantillas.filter(p => !p.isDefault);
        this.defaultPlantillas  = todasPlantillas.filter(p => p.isDefault);
        this.allGrupos = this.buildGroups(companyPlantillas);
        this.setPage({ offset: 0 });
      },
      error: () => {
        this.loading = false;
        this.componentStarted = true;
        Swal.fire({ icon: 'error', title: 'Error', text: 'No fue posible cargar las plantillas. Intente nuevamente.' });
        this.ref.detectChanges();
      }
    });
  }

  setPage(pageInfo: { offset: number }): void {
    this.page.pageNumber = pageInfo.offset;
    const start = this.page.pageNumber * this.page.pageSize;
    const end = start + this.page.pageSize;
    this.rowsMantenedor = this.allGrupos.slice(start, end);
    this.page.totalElements = this.allGrupos.length;
    this.page.totalPages = Math.ceil(this.allGrupos.length / this.page.pageSize);
    this.loading = false;
    this.componentStarted = true;
    this.ref.detectChanges();
  }

  setPageSize(): void {
    this.setPage({ offset: 0 });
  }


  private buildGroups(companyPlantillas: PlantillaImpresion[]): GrupoDte[] {
    const grupos: GrupoDte[] = [];
    const codigosEmpresa  = new Set(companyPlantillas.map(p => p.codigoTipoDte));
    const codigosDefault  = new Set(this.defaultPlantillas.map(p => p.codigoTipoDte));
    const todosCodigos    = [...new Set([...codigosEmpresa, ...codigosDefault])].sort((a, b) => a - b);

    for (const codigo of todosCodigos) {
      const tipoDte = this.tipoDteSource.find(t => t.codigosii === codigo);
      const nombreTipoDte = tipoDte?.nombre || `Tipo DTE ${codigo}`;
      const plantillasGrupo = companyPlantillas.filter(p => p.codigoTipoDte === codigo);

      const cartas  = plantillasGrupo.filter(p => !this.isTicket(p.tipoPapel));
      const tickets = plantillasGrupo.filter(p => this.isTicket(p.tipoPapel));
      const opciones: PlantillaOpcion[] = [];
      let personalizadoIndex = 1;

      for (const carta of cartas) {
        opciones.push({ label: `Personalizado ${personalizadoIndex++}`, plantilla: carta, esPersonalizada: true, isDefault: false });
      }
      const defCarta = this.defaultPlantillas.find(p => p.codigoTipoDte === codigo && !this.isTicket(p.tipoPapel));
      if (defCarta) {
        opciones.push({ label: 'Defecto', plantilla: defCarta, esPersonalizada: false, isDefault: true });
      }

      for (const ticket of tickets) {
        opciones.push({ label: `Personalizado ${personalizadoIndex++}`, plantilla: ticket, esPersonalizada: true, isDefault: false });
      }
      const defTicket = this.defaultPlantillas.find(p => p.codigoTipoDte === codigo && this.isTicket(p.tipoPapel));
      if (defTicket) {
        opciones.push({ label: 'Defecto', plantilla: defTicket, esPersonalizada: false, isDefault: true });
      }

      const activa = opciones.find(o => o.plantilla.activo) || opciones[0] || null;
      if (activa) { activa.asignada = true; }

      const tiposPapel = ['Todos', ...[...new Set(opciones.map(o => o.plantilla.tipoPapel))].sort()];
      const papelSeleccionado = 'Todos';
      const opcionesFiltradas = this.filtrarYOrdenar(opciones, 'Todos');

      grupos.push({ codigoTipoDte: codigo, nombreTipoDte, opciones, tiposPapel, papelSeleccionado, opcionesFiltradas, seleccionada: activa, prevSeleccionada: activa });
    }

    return grupos;
  }

  private isTicket(tipoPapel: string): boolean {
    if (!tipoPapel) return false;
    const lower = tipoPapel.toLowerCase();
    return lower.includes('ticket') || lower.includes('58mm');
  }

  private filtrarYOrdenar(opciones: PlantillaOpcion[], papel: string): PlantillaOpcion[] {
    const base = papel === 'Todos' ? opciones : opciones.filter(o => o.plantilla.tipoPapel === papel);
    return [
      ...base.filter(o => o.isDefault),
      ...base.filter(o => !o.isDefault)
    ];
  }

  getEtiquetaBadgeClass(label: string): string {
    if (label === 'Defecto') return 'badge-secondary';
    return 'badge-info';
  }

  onPapelChange(grupo: GrupoDte): void {
    grupo.opcionesFiltradas = this.filtrarYOrdenar(grupo.opciones, grupo.papelSeleccionado);
    grupo.seleccionada = grupo.opcionesFiltradas.find(o => o.asignada) || grupo.opcionesFiltradas[0] || null;
    grupo.prevSeleccionada = grupo.seleccionada;
    this.rowsMantenedor = [...this.rowsMantenedor];
    this.ref.detectChanges();
  }

  onSeleccionChange(grupo: GrupoDte): void {
    this.rowsMantenedor = [...this.rowsMantenedor];
    this.ref.detectChanges();
  }

  puedeAsignar(grupo: GrupoDte): boolean {
    if (!grupo.seleccionada) return false;
    return !grupo.seleccionada.asignada;
  }

  asignarPlantilla(grupo: GrupoDte): void {
    const nueva = grupo.seleccionada;
    if (!nueva || nueva.asignada) return;

    Swal.fire({
      icon: 'question',
      title: '¿Asignar plantilla?',
      html: `A partir de este momento, los documentos de tipo <strong>${grupo.nombreTipoDte}</strong> se emitirán con la plantilla <strong>${nueva.plantilla.descripcion}</strong>.`,
      showCancelButton: true,
      confirmButtonText: 'Asignar',
      cancelButtonText: 'Cancelar',
      confirmButtonColor: '#3699FF',
      cancelButtonColor: '#b5b5c3'
    }).then(result => {
      if (result.isConfirmed) {
        this.loading = true;
        this.emisorService.getEmisor(this.emisorId).subscribe({
          next: (response) => {
            const plantillaEmisor = new PlantillaEmisor();
            plantillaEmisor.emisorAsociado = response.data;
            plantillaEmisor.plantillaEmisorId = nueva.plantilla.plantillaEmisorId;
            plantillaEmisor.emisorId = this.emisorId;
            plantillaEmisor.tipoPlantillaId = nueva.plantilla.tipoPlantillaId;
            plantillaEmisor.activo = true;
            plantillaEmisor.nombrePlantilla = nueva.plantilla.descripcion;
            this.plantillaService.activatePlantilla(plantillaEmisor).subscribe({
              next: () => {
                this.loading = false;
                grupo.opciones.forEach(o => o.asignada = false);
                nueva.asignada = true;
                grupo.seleccionada = nueva;
                grupo.prevSeleccionada = nueva;
                grupo.opcionesFiltradas = this.filtrarYOrdenar(grupo.opciones, grupo.papelSeleccionado);
                this.rowsMantenedor = [...this.rowsMantenedor];
                this.ref.detectChanges();
                Swal.fire({ icon: 'success', title: 'Plantilla asignada', text: 'La plantilla fue asignada correctamente.' });
              },
              error: (error) => {
                this.loading = false;
                Swal.fire({ icon: 'error', title: 'Error', text: 'No se pudo asignar la plantilla. ' + this.utilities.setErrorMessageFromArray(error.error) });
              }
            });
          },
          error: (error) => {
            this.loading = false;
            Swal.fire({ icon: 'error', title: 'Error', text: 'No se pudo obtener los datos de la plantilla. ' + this.utilities.setErrorMessageFromArray(error.error) });
          }
        });
      }
    });
  }


  abrirEditarModal(grupo: GrupoDte, modalRef: any): void {
    this.plantillaEditando = { ...grupo.seleccionada.plantilla };
    this.nuevoNombre = grupo.seleccionada.plantilla.descripcion;
    this.editModalRef = this.modalService.open(modalRef, { size: 'sm', centered: true });
  }

  guardarNombre(): void {
    if (!this.plantillaEditando || !this.nuevoNombre.trim()) return;
    this.loading = true;
    const request: PlantillaImpresion = { ...this.plantillaEditando, descripcion: this.nuevoNombre.trim(), file: null as any };
    this.plantillaService.editPlantillaRequest(request).subscribe({
      next: () => {
        this.editModalRef.close();
        this.loading = false;
        Swal.fire({ icon: 'success', title: 'Nombre actualizado', text: 'El nombre de la plantilla fue actualizado correctamente.' });
        this.loadData();
      },
      error: (error) => {
        this.loading = false;
        Swal.fire({ icon: 'error', title: 'Error', text: 'No se pudo actualizar el nombre. ' + this.utilities.setErrorMessageFromArray(error.error) });
      }
    });
  }

  cancelarEdicion(): void {
    if (this.editModalRef) this.editModalRef.close();
  }
  eliminarPlantilla(grupo: GrupoDte): void {
    this.loading = true;
    const plantillaEmisorId = grupo.seleccionada?.plantilla.plantillaEmisorId;
    const codigodte = grupo.codigoTipoDte;
    this.plantillaService.removeEmisorFromPlantilla(plantillaEmisorId, codigodte).subscribe({
      next: () => {
        this.loading = false;
        Swal.fire({ icon: 'success', title: 'Plantilla desasignada', text: 'La plantilla ha sido desasignada de su empresa.' });
        this.loadData();
      },
      error: (error) => {
        this.loading = false;
        Swal.fire({ icon: 'error', title: 'Error', text: 'No se pudo desasignar la plantilla. ' + this.utilities.setErrorMessageFromArray(error.error) });
      }
    });
  }

  previsualizarPlantilla(grupo: GrupoDte): void {
    const plantilla = grupo.seleccionada.plantilla;
    const codigo = plantilla.codigoTipoDte;
    this.loading = true;

    if (codigo === 110 || codigo === 111 || codigo === 112) {
      this.plantillaService.getPdfSampleExporta(plantilla).subscribe({
        next: (result) => {
          this.loading = false;
          this.ref.detectChanges();
          if (!result.data) {
            Swal.fire({ icon: 'error', title: 'Error al obtener muestra', text: 'No es posible renderizar la muestra asociada a esta plantilla de impresión.' });
            return;
          }
          this.responseToPdfDownload(result.data, plantilla);
        },
        error: (error) => {
          this.loading = false;
          this.ref.detectChanges();
          Swal.fire({ icon: 'error', title: 'Error al obtener muestra', text: 'No es posible renderizar la muestra asociada a esta plantilla de impresión. ' + this.utilities.setErrorMessageFromArray(error.error) });
        }
      });
    } else {
      this.plantillaService.getPdfSample(plantilla, this.emisorId).subscribe({
        next: (result) => {
          this.loading = false;
          this.ref.detectChanges();
          if (!result.data) {
            Swal.fire({ icon: 'error', title: 'Error al obtener muestra', text: 'No es posible renderizar la muestra asociada a esta plantilla de impresión.' });
            return;
          }
          this.responseToPdfDownload(result.data, plantilla);
        },
        error: (error) => {
          this.loading = false;
          this.ref.detectChanges();
          Swal.fire({ icon: 'error', title: 'Error al obtener muestra', text: 'No es posible renderizar la muestra asociada a esta plantilla de impresión. ' + this.utilities.setErrorMessageFromArray(error.error) });
        }
      });
    }
  }

  private responseToPdfDownload(responseB64: string, plantilla: PlantillaImpresion): void {
    const pdfBlob = this.utilities.convertB64ToBlob(responseB64, 'application/pdf');
    if (pdfBlob.size > 0) {
      const fileURL = URL.createObjectURL(pdfBlob);
      this.popupCenter(fileURL, 'PDF', 600, 800);
    }
  }

  private popupCenter(url: string, title: string, w: number, h: number): void {
    const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
    const dualScreenTop  = window.screenTop  !== undefined ? window.screenTop  : window.screenY;
    const width  = window.innerWidth  || document.documentElement.clientWidth  || screen.width;
    const height = window.innerHeight || document.documentElement.clientHeight || screen.height;
    const systemZoom = width / window.screen.availWidth;
    const left = (width  - w) / 2 / systemZoom + dualScreenLeft;
    const top  = (height - h) / 2 / systemZoom + dualScreenTop;
    window.open(url, title, `width=${w / systemZoom},height=${h / systemZoom},top=${top},left=${left}`);
  }
}

